module.exports = __webpack_public_path__ + "static/portfolio_gallery_5-619d9a836027588bcca6101662035eb2.jpg";